import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "alm-react-components";
import { fetchUserAttributes, signOut } from "aws-amplify/auth";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import {
  ActionType,
  APPROUTES,
  CurrencyOptions,
  SubscriptionStatus,
} from "../../../assets/constants/constants";
import { AppContext } from "../../../context/AppProvider";
import { getSllUser } from "../../../services/user";
import PageLoader from "../../common/loader/PageLoader";

export const SelectCurrency = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [currency, setCurrency] = useState(CurrencyOptions[0]);
  const { t } = useTranslation();
  const [showButton, setShowButton] = useState<boolean>(false);
  const [redrection, setRedrection] = useState<string>("");

  useEffect(() => {
    fetchUser();
  }, [state.loading]);

  const fetchUser = async () => {
    setLoading(true);
    const fetchUserAttributesData: any = await fetchUserAttributes().catch(() =>
      navigate("/")
    );
    getSllUser(fetchUserAttributesData.email)
      .then((res: any) => {
        if(res.data?.corporateAccountId) {
          navigate("/")
        }else{
            if (
            res.data.subscriptionStatus === SubscriptionStatus.active ||
            res.data.subscriptionStatus === SubscriptionStatus.trial
          ) {
            setRedrection(APPROUTES.userSettings);
          } else if (
            res.data.subscriptionStatus === SubscriptionStatus.canceled ||
            res.data.subscriptionStatus === SubscriptionStatus.trialOver
          ) {
            setRedrection("/");
          }
        }
        setLoading(false);
      })
      .catch(() => navigate("/"));
  };

  const onValueChange = (value: any) => {
    setCurrency(value);
  };

  async function onhandleSubmit(values: any) {
    if (values.currency) {
      localStorage.setItem("currency", currency);
      navigate(APPROUTES.selectMembership);
    }
  }
  const schema = yup.object({ currency: yup.string().required() }).required();

  const form = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: {
      currency: CurrencyOptions[0],
    },
  });

  const doRerection = async () => {
    if(redrection === '/') {
      dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: true });
      await signOut({
        global: true,
      }).catch(error => {
        dispatch({ type: ActionType.LOTTIE_ANIMATION, payload: false });
        console.log('logOut-------', error);
      });
    }
    navigate(`${redrection}`);
  };

  return (
    <>
      {loading ? (
        <PageLoader /> // Show the loader while loading
      ) : (
        <div className="grid md:grid-cols-1 md:w-[585px] mx-auto">
          <Card className="text-base bg-transparent border-0 md:min-w-[486px] md:max-w-[486px] px-4 md:mx-auto">
            <CardHeader className="block px-0">
              <CardTitle
                className="text-4xl font-light font-barlowLight"
                dangerouslySetInnerHTML={{ __html: t("Common.selectCurrency") }}
              />
            </CardHeader>
            <CardContent className="px-0">
              <CardDescription className="text-lg dark:text-white pb-10">
                <Form {...form}>
                  <form onSubmit={form.handleSubmit(onhandleSubmit)}>
                    <FormField
                      control={form.control}
                      name="currency"
                      render={() => (
                        <FormItem>
                          <FormLabel
                            className="font-opensansSemiBold text-base font-opensansMedium tracking-wider"
                            dangerouslySetInnerHTML={{
                              __html: t("Common.selectCurrency"),
                            }}
                          />

                          <Select
                            onValueChange={onValueChange}
                            value={currency}
                            onOpenChange={(e) => setShowButton(e)}
                          >
                            <FormControl>
                              <SelectTrigger className="h-auto py-4 text-base">
                                <SelectValue
                                  placeholder={
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: t("Common.selectCurrency"),
                                      }}
                                    />
                                  }
                                />
                              </SelectTrigger>
                            </FormControl>
                            <SelectContent>
                              {CurrencyOptions.map((res: any, key: number) => {
                                return (
                                  <div key={`currencyc-${key}`}>
                                    <SelectGroup key={`currencya-${key}`}>
                                      <SelectItem
                                        key={`currency-${key}`}
                                        value={res}
                                      >
                                        {t(`Common.${res}`)}
                                      </SelectItem>
                                    </SelectGroup>
                                  </div>
                                );
                              })}
                            </SelectContent>
                          </Select>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                    <div className="flex justify-between gap-4">
                      {redrection && (
                        <div className="flex justify-between grid-4 space-x-3 pt-3 w-full">
                          <span
                            onClick={doRerection}
                            className="flex w-full h-auto py-3 border rounded-[10px] justify-center font-normal text-lg cursor-pointer"
                            dangerouslySetInnerHTML={{
                              __html: redrection === '/' ? t('MembershipSuccess.signOut') : t("Common.cancel"),
                            }}
                          ></span>
                        </div>
                      )}
                      <div className="flex justify-between grid-4 space-x-3 pt-3 w-full">
                        <Button
                          disabled={showButton}
                          className="w-full h-auto py-3 text-base"
                          dangerouslySetInnerHTML={{
                            __html: t("MembershipPlan.continue"),
                          }}
                        ></Button>
                      </div>
                    </div>
                  </form>
                </Form>
              </CardDescription>
            </CardContent>
          </Card>
        </div>
      )}
    </>
  );
};
